<template>
  <div v-if="form">
    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <!-- Header: Personal Info -->
      <div class="d-flex mt-2">
        <feather-icon
          icon="MapPinIcon"
          size="19"
        />
        <h4 class="mb-0 ml-50">
          地址
        </h4>
      </div>

      <!-- Form: Personal Info Form -->
      <b-row class="mt-1">

        <!-- Field: Address Line 1 -->
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="地址"
            label-for="address"
          >
            <b-form-input
              id="address"
              v-model="form.address"
              @change="checkDiff"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Country -->
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="國家"
            label-for="country"
          >
            <b-form-input
              id="country"
              v-model="form.country"
              placeholder="台灣"
              @change="checkDiff"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Postcode -->
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="郵遞區號"
            label-for="zip"
          >
            <b-form-input
              id="postcode"
              v-model="form.zip"
              type="number"
              placeholder="10688"
              @change="checkDiff"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
        >
          <img :src="googleMapURL">
        </b-col>

      </b-row>

      <b-row class="mt-2">
        <b-col>
          <!-- Action Buttons -->
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            :disabled="btnDisable"
            @click="saveChanges"
          >
            <div v-if="submit">
              <b-spinner small />
              <span class="sr-only">更新中...</span>
            </div>
            <div v-else-if="!success">
              儲存變更
            </div>
            <div v-else-if="success">
              已儲存
            </div>
          </b-button>
          <b-button
            v-if="btnReset"
            variant="outline-secondary"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="setDefault"
          >
            取消
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner,
} from 'bootstrap-vue'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  components: {
    BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner,
  },
  data() {
    return {
      form: null,
      btnDisable: true,
      btnReset: false,
      success: false,
      update: false,
      submit: false,
      googleMap: {
        baseURL: `https://maps.googleapis.com/maps/api/staticmap?key=${process.env.VUE_APP_MAP_KEY}`,
        zoom: 17,
        markers: {
          lat: 25.0401,
          lng: 121.5120,
          size: 'normal',
          icon: 'https://trackhelps.com/assets/img/Logo_32x32.png',
        },
        language: 'zh-tw',
        format: 'png',
        maptype: 'raodmap',
        size: '400x206',
        scale: '1',
        style: 'feature:poi|visibility:off',
      },
      googleMapURL: '',
    }
  },
  computed: {
    ...mapGetters(['user', 'campaign', 'userCampaigns']),
  },
  mounted() {
    this.setDefault()
  },
  methods: {
    setDefault() {
      this.form = {
        address: this.campaign.address,
        country: this.campaign.country,
        zip: this.campaign.zip,
      }
      this.googleMapURL = this.campaign.mapImgURL
      this.btnDisable = true
      this.btnReset = false
      this.success = false
      this.update = false
      this.submit = false
    },
    checkDiff() {
      this.success = false

      if ((this.form.address !== this.campaign.address) || (this.form.country !== this.campaign.country) || (this.form.zip !== this.campaign.zip)) {
        if (!this.form.address === '' || !this.form.country === '' || !this.form.zip === '') {
          this.btnDisable = true
          this.update = false
        } else {
          this.btnDisable = false
          this.update = true
          this.btnReset = true
        }
      } else {
        this.btnDisable = true
        this.update = false
        this.btnReset = false
      }
    },
    saveChanges() {
      this.submit = true
      this.btnDisable = true

      if (this.update) {
        this.update = false
        const adds = `${this.form.address}, ${this.form.country}, ${this.form.zip}`
        store.dispatch('geoAddress', adds).then(campaign => {
          this.form.geoLocation = campaign.geoLocation
          this.googleMap.markers.lat = campaign.geoLocation.lat
          this.googleMap.markers.lng = campaign.geoLocation.lng
          this.form.formattedAddress = campaign.formattedAddress
          this.setMapUrl().then(() => {
            store.dispatch('updateCampaign', {
              data: this.form,
              campaign: this.campaign,
              userCampaigns: this.userCampaigns,
              uid: this.user.uid,
            }).then(() => {
              fetch(this.googleMapURL).then(res => res.blob()).then(blob => {
                store.dispatch('uploadCampaignImage', {
                  data: blob, name: `${this.campaign.cid}-gmap`, uid: this.campaign.cuid, type: 'blob', cid: this.campaign.cid, colName: 'mapImgURL',
                })
              })
              this.success = true
              this.submit = false
            }).catch(() => {
              this.submit = false
            })
          })
        }).catch(() => {
          this.submit = false
        })
      }
    },
    setMapUrl() {
      return new Promise(resolve => {
        this.googleMapURL = this.googleMap.baseURL
        Object.entries(this.googleMap).forEach(([key, item]) => {
          if (key === 'markers') {
            this.googleMapURL += `&markers=size:${this.googleMap.markers.size}|icon:${this.googleMap.markers.icon}|${this.googleMap.markers.lat},${this.googleMap.markers.lng}`
          } else if (key !== 'baseURL' && key !== 'key') {
            this.googleMapURL += `&${key}=${item}`
          }
        })
        resolve()
      })
    },
  },
}
</script>
